import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { Icon, Button } from 'LocalGluons';
import styles from './BuyMoreStorageDialog.jss';

const buttonStyle = {
    button: {
        ...styles.button,
        width: '100%'
    }
};

const BuyMoreStorageDialog = ({ close }) => (
    <View style={styles.window}>
        <Icon style={styles.closeIcon} name="close" onPress={close} />
        <Text style={styles.title}>{t('RECORDINGS.STORAGE_NOTICE.TITLE')}</Text>
        <View style={styles.line} />
        <Text style={styles.greyText}>{t('RECORDINGS.STORAGE_NOTICE.GREY_TEXT')}</Text>
        <Text style={styles.whiteText}>{t('RECORDINGS.STORAGE_NOTICE.WHITE_TEXT_1')}</Text>
        <Text style={styles.whiteText}>{t('RECORDINGS.STORAGE_NOTICE.WHITE_TEXT_2')}</Text>
        <Button style={buttonStyle} title={t('COMMON.RECORDINGS_GOT_IT_BTN')} onPress={close} />
    </View>
);

BuyMoreStorageDialog.propTypes = {
    close: PropTypes.func.isRequired
};

export default BuyMoreStorageDialog;
